import { ResponsiveTable, Typography } from 'procyon-ui'
import React from 'react'
import { columns, useTopUsersTable } from './TopUsersTable.utils'
import TopUsersTableSkeleton from './TopUsersTableSkeleton'
import { useDashboardDataProvider } from 'features/dashboard'

const TopUsersTable = ({}) => {
  const { rowData, startDays } = useTopUsersTable()
  const { overallLoading } = useDashboardDataProvider()

  return (
    <div className='border rounded p-5 w-[100%] h-[480px] overflow-auto bg-[var(--color-common-bg-base)] border-[var(--color-common-border)]'>
      <Typography variant='h4-regular' style={{ color: 'var(--color-font-base)' }}>
        Top Users
      </Typography>
      <Typography
        style={{ color: '--color-font-light' }}
        className='!text-gray-400'
        variant='body-regular'
      >
        sessions last {startDays} days
      </Typography>
      <div className='mt-6'>
        <ResponsiveTable columns={columns()} data={rowData} pagination={{ pageSize: 5 }} />
      </div>
    </div>
  )
}

export { TopUsersTable }
